import { DateInput } from "@blueprintjs/datetime"
import StaticSelector from "components/Atoms/StaticSelector"
import QueryBar from "components/Common/QueryBar"
import TablePagination from "components/Molecules/TablePagination"
import SubHeader from "components/Organisms/SubHeader"
import dayjs from "dayjs"
import React from "react"
import { useSearchParams } from "react-router-dom"
import clsx from "utils/clsx"
import BeatCalendar from "../beat/BeatCalendar"
import SalesManList from "../beat/SalesManList"
import MonitorListView from "./MonitorListView"

const items = [
  {
    id: "area",
    name: "Area",
  },
  {
    id: "calendar",
    name: "Calendar",
  },
]
const BeatMonitoringList = () => {
  const [params, setParams] = useSearchParams()

  const type = params.get("type") || "area"
  const page = parseInt(params.get("page") || "0")
  const date = params.get("date") || dayjs().format("YYYY-MM-DD")
  const search = params.get("search")
  // const isSummaryOpen = !!parseInt(summaryOpen)

  function handleParamChange(path?: string, value?: any) {
    params.set(path, value)
    setParams(params)
  }
  return (
    <SubHeader
      className={clsx(
        "flex overflow-hidden h-content",
        type === "area" && "flex-col",
        type === "calendar" && "gap-3"
      )}
      showBackButton={false}
      header={
        <>
          <div className="flex items-center">
            <StaticSelector
              value={items.find(item => item.id === type)}
              onChange={(_, value) => {
                params.set("type", value.id)
                setParams(params)
              }}
              items={items}
              className="mb-0 mr-3"
            />
            {/* <SegmentedControl
              css
              size="sm"
              data={[
                { label: "Map", value: "map" },
                { label: "List", value: "list" },
              ]}
              value={view}
              onChange={value => {
                handleParamChange("view", value)
              }}
            /> */}
          </div>
          <div className="flex">
            <QueryBar
              value={search}
              onChange={query => {
                handleParamChange("search", query)
                handleParamChange("page", 0)
              }}
              round={false}
            />
            {/* <Button
              onClick={() => {
                handleParamChange("summaryOpen", isSummaryOpen ? "0" : "1")
              }}
              className="ml-3"
              minimal
              icon={isSummaryOpen ? "eye-open" : "eye-off"}
            /> */}
          </div>
          <div className="flex">
            <TablePagination
              className="mr-3"
              page={page}
              onPageChange={page => handleParamChange("page", page)}
            />
            <DateInput
              shortcuts
              formatDate={date => dayjs(date).format("Do MMM YYYY")}
              value={dayjs(date).toDate()}
              onChange={date => {
                handleParamChange("date", dayjs(date).format("YYYY-MM-DD"))
              }}
              placeholder="DD/MM/YYYY"
              inputProps={{
                leftIcon: "calendar",
              }}
            />
          </div>
        </>
      }
    >
      {/* <BeatOverview
        isOpen={isSummaryOpen}
        onClose={() => {
          handleParamChange("summaryOpen", "0")
        }}
      /> */}
      {type === "area" ? (
        <div className="p-3">
          <MonitorListView />
        </div>
      ) : (
        <>
          <SalesManList />
          <BeatCalendar />
        </>
      )}
    </SubHeader>
  )
}

export default BeatMonitoringList
